<template>
    <div class="installationProperties installationProperties__zones" style="min-height: 0;">
        <p class="titleSection"></p>
        <template v-if="show">
            <div class="modes-wrap">
                <ui-IcoBtn
                    :sizeLg="true"
                    :active="modeHeat"
                    :label="$dicc.hot"
                    valueIco="mode-heat"
                    @click="$emit('setHeat')"
                />
                <ui-IcoBtn
                    :sizeLg="true"
                    :active="!modeHeat"
                    :label="$dicc.cool"
                    valueIco="mode-cool"
                    classStyles="ms-2"
                    @click="$emit('setCool')"
                />
            </div>
            <!--
            <div class="tempControlInstallation-wrap">
                <ui-TempControlInstallation
                    :active="false"
                    :order="order | toNumber"
                    buttonText="unificar temperatura"
                ></ui-TempControlInstallation>
            </div>
            -->
            <div class="switch-wrap">
                <ui-Switch
                    :status="active"
                    :disabled="!active"
                    :standby="false"
                    @update:status="$emit('stop')"
                ></ui-Switch>
            </div>
        </template>
    </div>
</template>

<script>
    import ui_Ico from './ui-Ico.vue';

    export default {
        components: { ui_Ico },
        name: 'ui-InstallationProperties',
        props: {
            modeHeat: {
                type: Boolean,
                default: false,
            },
            active: {
                type: Boolean,
                default: false,
            },
            show: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
